/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { InView } from 'react-intersection-observer';

import placeholder from '../images/placeholder.png';

class Thumbnail extends React.PureComponent {
  render() {
    const {
      title,
      slug,
      imageUrl,
      imageAlt,
      firstCreditRole,
      firstCreditPersonOrCompany,
      secondCreditRole,
      secondCreditPersonOrCompany,
      thirdCreditRole,
      thirdCreditPersonOrCompany,
      isLoading,
      location,
    } = this.props;

    return (
      <InView
        rootMargin="16px 0px"
        triggerOnce
      >
        {({ inView, ref }) => (
          <article
            ref={ref}
            className={`Thumbnail ${
              inView && !isLoading ? 'Thumbnail--active' : ''
            } ${
              isLoading ? 'Thumbnail--loading' : ''
            }`}
          >
            <InView
              rootMargin="-15% 0px 0px 0px"
              threshold={1}
            >
              {({ inView, ref }) => (
                <Link
                  ref={ref}
                  to={{
                    pathname: `/${slug}`,
                    state: { background: location },
                  }}
                  className={`Thumbnail__link ${
                    inView && !isLoading ? 'Thumbnail__link--active' : ''
                  }`}
                >
                  <InView
                    rootMargin="225px 0px"
                    triggerOnce
                  >
                    {({ inView, ref }) => (
                      <img
                        ref={ref}
                        src={inView && imageUrl ? imageUrl : placeholder}
                        alt={imageAlt}
                        width="900"
                        height="450"
                        className="Thumbnail__image"
                      />
                    )}
                  </InView>
                  <div className="Thumbnail__mask Thumbnail__mask--opacity" />
                  <div className="Thumbnail__mask Thumbnail__mask--blend" />
                  <div className="Thumbnail__content">
                    <div className="Thumbnail__container">
                      <h2
                        className="Thumbnail__title"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: title }}
                      />
                      {firstCreditRole && firstCreditPersonOrCompany && (
                        <div className="Thumbnail__credit">
                          <h3
                            className="Thumbnail__role"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: firstCreditRole }}
                          />
                          <span
                            className="Thumbnail__person-or-company"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: firstCreditPersonOrCompany }}
                          />
                        </div>
                      )}
                      {secondCreditRole && secondCreditPersonOrCompany && (
                        <div className="Thumbnail__credit">
                          <h3
                            className="Thumbnail__role"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: secondCreditRole }}
                          />
                          <span
                            className="Thumbnail__person-or-company"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: secondCreditPersonOrCompany }}
                          />
                        </div>
                      )}
                      {thirdCreditRole && thirdCreditPersonOrCompany && (
                        <div className="Thumbnail__credit">
                          <h3
                            className="Thumbnail__role"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: thirdCreditRole }}
                          />
                          <span
                            className="Thumbnail__person-or-company"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: thirdCreditPersonOrCompany }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </Link>
              )}
            </InView>
          </article>
        )}
      </InView>
    );
  }
}

Thumbnail.propTypes = {
  title: PropTypes.string,
  slug: PropTypes.string,
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,
  firstCreditRole: PropTypes.string,
  firstCreditPersonOrCompany: PropTypes.string,
  secondCreditRole: PropTypes.string,
  secondCreditPersonOrCompany: PropTypes.string,
  thirdCreditRole: PropTypes.string,
  thirdCreditPersonOrCompany: PropTypes.string,
  isLoading: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
};

Thumbnail.defaultProps = {
  title: '',
  slug: '',
  imageUrl: '',
  imageAlt: '',
  firstCreditRole: '',
  firstCreditPersonOrCompany: '',
  secondCreditRole: '',
  secondCreditPersonOrCompany: '',
  thirdCreditRole: '',
  thirdCreditPersonOrCompany: '',
  isLoading: false,
};

export default withRouter(Thumbnail);
